export class Polyline {

    public encodedstring: string;

    constructor(PolylineString: string) {
        this.encodedstring = PolylineString;
    }

    public decodepolyline(): any[] {
        return this.decodepolylineSegments().reduce((points, segment) => points.concat(segment), []);
    }

    public decodepolylineSegments(): any[][] {
        return this.encodedstring
            .split(';')
            .filter((segment) => segment.length > 0)
            .reduce((segments, segment) => {
                try {
                    const points = segment.charAt(0) === 'B'
                        ? this.decodeFlexiblePolyline(segment)
                        : this.decodeLegacyPolyline(segment);
                    if (points.length > 1 && points.every((point) =>
                        isFinite(point.latitude) && isFinite(point.longitude) &&
                        Math.abs(point.latitude) <= 90 && Math.abs(point.longitude) <= 180)) {
                        segments.push(points);
                    }
                    return segments;
                } catch (_) {
                    return segments;
                }
            }, []);
    }

    private decodeLegacyPolyline(encoded: string): any[] {
        const points = [];
        let index = 0;
        const len = encoded.length;
        let lat = 0;
        let lng = 0;
        while (index < len) {
            let b, shift = 0, result = 0;
            do {
                b = encoded.charAt(index++).charCodeAt(0) - 63;
                if (!isFinite(b)) {
                    throw new Error('Invalid legacy polyline');
                }
                result |= (b & 0x1f) << shift;
                shift += 5;
            } while (b >= 0x20);

            const dlat = ((result & 1) !== 0 ? ~(result >> 1) : (result >> 1));
            lat += dlat;
            shift = 0;
            result = 0;
            do {
                b = encoded.charAt(index++).charCodeAt(0) - 63;
                if (!isFinite(b)) {
                    throw new Error('Invalid legacy polyline');
                }
                result |= (b & 0x1f) << shift;
                shift += 5;
            } while (b >= 0x20);
            const dlng = ((result & 1) !== 0 ? ~(result >> 1) : (result >> 1));
            lng += dlng;

            points.push({ latitude: (lat / 1E6), longitude: (lng / 1E6) });

        }
        return points;
    }

    private decodeFlexiblePolyline(encoded: string): any[] {
        const values = [];
        let value = 0;
        let shift = 0;
        const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_';
        for (let index = 0; index < encoded.length; index++) {
            const current = alphabet.indexOf(encoded.charAt(index));
            if (current < 0) {
                throw new Error('Invalid flexible polyline character');
            }
            value += (current & 0x1f) * Math.pow(2, shift);
            if ((current & 0x20) === 0) {
                values.push(value);
                value = 0;
                shift = 0;
            } else {
                shift += 5;
            }
        }
        if (shift !== 0 || values.length < 2 || values[0] !== 1) {
            throw new Error('Invalid flexible polyline header');
        }

        const header = values[1];
        const precision = header & 15;
        const thirdDimension = (header >> 4) & 7;
        const thirdDimensionPrecision = (header >> 7) & 15;
        if (thirdDimension === 4 || thirdDimension === 5) {
            throw new Error('Invalid flexible polyline third dimension');
        }

        const factor = Math.pow(10, precision);
        const thirdFactor = Math.pow(10, thirdDimensionPrecision);
        const points = [];
        const coordinateSize = thirdDimension === 0 ? 2 : 3;
        if ((values.length - 2) % coordinateSize !== 0) {
            throw new Error('Truncated flexible polyline');
        }
        let latitude = 0;
        let longitude = 0;
        let third = 0;
        let index = 2;
        while (index + 1 < values.length) {
            latitude += this.toSigned(values[index++]);
            longitude += this.toSigned(values[index++]);
            const point: any = {
                latitude: latitude / factor,
                longitude: longitude / factor
            };
            if (thirdDimension !== 0 && index < values.length) {
                third += this.toSigned(values[index++]);
                point.thirdDimension = third / thirdFactor;
            }
            if (!isFinite(point.latitude) || !isFinite(point.longitude) ||
                Math.abs(point.latitude) > 90 || Math.abs(point.longitude) > 180) {
                throw new Error('Invalid flexible polyline coordinates');
            }
            points.push(point);
        }
        return points;
    }

    private toSigned(value: number): number {
        return value % 2 !== 0 ? -Math.floor(value / 2) - 1 : value / 2;
    }

}
